/* eslint-disable camelcase */
import React from "react"
import { Paper, Grid, Typography, Box, Chip } from "@mui/material"
import PersonIcon from "@mui/icons-material/Person"
import LocalHospitalIcon from "@mui/icons-material/LocalHospital"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import AssignmentIcon from "@mui/icons-material/Assignment"

const HeaderContexto = ({ contexto, etapa }) => {
  const isCerrada = contexto.car_status === "CERRADA"

  return (
    <Paper elevation={3} sx={{ p: 2, borderRadius: 2, borderLeft: `6px solid ${isCerrada ? "#4caf50" : "#196C87"}` }}>
      <Grid container spacing={2} alignItems="center">
        {/* Identificación de la Carpeta */}
        <Grid item xs={12} md={3}>
          <Typography variant="caption" color="textSecondary">
            ID OPORTUNIDAD
          </Typography>
          <Typography variant="h6" fontWeight="bold" color="primary">
            {contexto.car_id}
          </Typography>
          <Chip
            label={contexto.car_status}
            color={isCerrada ? "success" : "primary"}
            size="small"
            sx={{ fontWeight: "bold", mt: 0.5 }}
          />
        </Grid>

        {/* Datos Clínicos */}
        <Grid item xs={12} md={4}>
          <Box display="flex" alignItems="center" mb={1}>
            <PersonIcon color="action" sx={{ mr: 1 }} />
            <Box>
              <Typography variant="caption" color="textSecondary" display="block">
                PACIENTE
              </Typography>
              <Typography variant="body2" fontWeight="bold">
                {contexto.paciente_nombre}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center">
            <LocalHospitalIcon color="action" sx={{ mr: 1 }} />
            <Box>
              <Typography variant="caption" color="textSecondary" display="block">
                MÉDICO ORIGEN
              </Typography>
              <Typography variant="body2">{contexto.medico_nombre}</Typography>
            </Box>
          </Box>
        </Grid>

        {/* Contexto del Proceso */}
        <Grid item xs={12} md={5}>
          <Box display="flex" alignItems="center" mb={1}>
            <AssignmentIcon color="action" sx={{ mr: 1 }} />
            <Box>
              <Typography variant="caption" color="textSecondary" display="block">
                TIPO DE NEGOCIO
              </Typography>
              <Typography variant="body2" fontWeight="bold">
                {contexto.pro_nombre}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center">
            <AccessTimeIcon color={etapa.eta_sla_horas > 0 ? "warning" : "action"} sx={{ mr: 1 }} />
            <Box>
              <Typography variant="caption" color="textSecondary" display="block">
                TIEMPO SLA (ETAPA ACTUAL)
              </Typography>
              <Typography variant="body2">
                {etapa.eta_sla_horas > 0 ? `Límite esperado: ${etapa.eta_sla_horas} horas` : "Sin límite de tiempo"}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default HeaderContexto
